import '../scss/main.scss';
import { ready } from './parts/utils';
import { initPreloader } from './parts/preloader';
import { initNavigation, initHeaderScrollState } from './parts/navigation';
import { initHeroAnimations, initRevealAnimations, initMediaTextAnimations, initCardsAnimations, initGetInTouchAnimations } from './parts/animations';

ready(() => {
  initPreloader();
  initNavigation();
  initHeaderScrollState();
  initHeroAnimations();
  initRevealAnimations();
  initMediaTextAnimations();
  initCardsAnimations();
  initGetInTouchAnimations();
});

